import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoot } from './app/App';
import { createApp } from './app/createApp';
import { startStravaReturnWindow } from './lib/strava';
import './theme/global.css';

startStravaReturnWindow();
const root = document.getElementById('root');
if (root === null) throw new Error('Missing #root element in index.html');
createRoot(root).render(
  <StrictMode>
    <AppRoot app={createApp()} />
  </StrictMode>,
);
